import { jsx } from "react/jsx-runtime";
import { createSvgIcon } from "@mui/material";
const AddIcon = createSvgIcon(
  /* @__PURE__ */ jsx("svg", { viewBox: "0 0 14 14", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ jsx(
    "path",
    {
      d: "M6.99999 1.16669C3.77824 1.16669 1.16666 3.77827 1.16666 7.00002C1.16666 10.2218 3.77824 12.8334 6.99999 12.8334C10.2217 12.8334 12.8333 10.2218 12.8333 7.00002C12.8333 3.77827 10.2217 1.16669 6.99999 1.16669ZM9.33332 7.58335H7.58332V9.33335C7.58332 9.65535 7.32199 9.91669 6.99999 9.91669C6.67799 9.91669 6.41666 9.65535 6.41666 9.33335V7.58335H4.66666C4.34466 7.58335 4.08332 7.32202 4.08332 7.00002C4.08332 6.67802 4.34466 6.41669 4.66666 6.41669H6.41666V4.66669C6.41666 4.34469 6.67799 4.08335 6.99999 4.08335C7.32199 4.08335 7.58332 4.34469 7.58332 4.66669V6.41669H9.33332C9.65532 6.41669 9.91666 6.67802 9.91666 7.00002C9.91666 7.32202 9.65532 7.58335 9.33332 7.58335Z",
      fill: "currentColor"
    }
  ) }),
  "Add"
);
export {
  AddIcon
};
